export const environment = {
    production: true,
    local: <boolean>false,
    serverUrl: "",
    notificationServerUrl: "notification.cree8.io",
};
